import { injectable } from 'inversify';
import env from '@framework/env/env';
import { DomainConfig } from '@framework/config/DI/domainModule/DomainConfig';
import { DataroomTenant } from '@dataroom/tenant/DataroomTenant';

@injectable()
export class DataroomDomainConfig extends DomainConfig {
  readonly domains: Record<DataroomTenant, string> = {
    dealvdr: env('DEALVDR_DOMAIN'),
    loansend: env('LOANSEND_DOMAIN'),
    '17g5': env('SEVENTEENG5_DOMAIN'),
    investorset: env('INVESTORSET_DOMAIN'),
    verisend: env('VERISEND_DOMAIN'),
    researchroom: env('RESEARCHROOM_DOMAIN'),
  };

  getDomain(tenant: DataroomTenant): string {
    const domain = this.domains[tenant];

    if (!domain) {
      throw new Error(`No domain found for tenant: ${ tenant }`);
    }
    return domain;
  }
}
